import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import {
  getActiveSection,
  getBatchAction,
  getIsSelectableDataset,
} from '../../selectors/studio';
import { Props } from './StudioTableHeader';

export type StateProps = Pick<
  Props,
  'activeSection' | 'batchAction' | 'canSelect'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeSection: getActiveSection(state),
  batchAction: getBatchAction(state),
  canSelect: getIsSelectableDataset(state),
});

export default connect(mapStateToProps);
